export const ListaKompanijaResourcesDE: ListaKompanijaResourcesBSInterface = {
  title: "Unternehmen",
  listaTacaka: "Anwendungspunkte",
  listaRadnihTacaka: "Arbeitsplatz und Benutzer",
  branchButton: "Filiale auswählen",
  next: "Weiter",
  back: "Zurück",
  branch: {
    placeholder: "Filiale auswählen",
    notFound: "Filiale nicht gefunden",
  },
  errorBranches: "Fehler beim Laden. Bitte kontaktieren Sie den Administrator.",
};

export interface ListaKompanijaResourcesBSInterface {
  title: string;
  listaTacaka: string;
  listaRadnihTacaka: string;
  branchButton: string;
  next: string;
  back: string;
  branch: {
    placeholder: string;
    notFound: string;
  };
  errorBranches: string;
}
